import TCard from './t-card.vue';

export default TCard;
